// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1azQS","clinicsSelect":"TableHeading_clinicsSelect__2Sj8P"};